import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchRedeemablePositions } from '@/lib/polymarketApi'
import type { RedeemablePosition } from '@/lib/polymarketApi'

/**
 * Data API: redeemable winning positions (curPrice === 1).
 * Polling 60s.
 */
export function useRedeemablePositions(address: string | null | undefined): {
  positions: RedeemablePosition[]
  totalUsdc: number
  isLoading: boolean
} {
  const enabled = Boolean(address && typeof address === 'string' && address.startsWith('0x'))
  const { data: positions = [], isLoading } = useQuery({
    queryKey: ['redeemablePositions', address ?? ''],
    queryFn: () => fetchRedeemablePositions(address!),
    enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
  const totalUsdc = useMemo(
    () => positions.reduce((sum, p) => sum + p.size, 0),
    [positions]
  )
  return { positions, totalUsdc, isLoading }
}
